

export default {
  getTask: state => postId => state.posts.find((post) => post.id === postId)
}
